const HeaderListFilter = ({ filterData }) => {
	return (
		<div className="flex flex-col">
			<ul className="text-[10px]">
				{filterData && typeof filterData === "object" && Object.entries(filterData).length > 0 ? (
					<>
						<strong>Filtros Aplicados</strong>
						{Object.entries(filterData).map(([key, { label, value }], index) => (
							<li key={`${key}-${index}`} className="">
								<strong>{label}:</strong> {value}
							</li>
						))}
					</>
				) : null}
			</ul>
		</div>
	);
};

export default HeaderListFilter;
